import React from 'react'
import Imageandtyping from './Imageandtyping'
import Header from './Header'
import desing from "./Images/desing.jpg"
const Combineheadertypin = () => {
  return (
    <div >
    
      <Header/>
      <Imageandtyping/>
    </div>
  )
}

export default Combineheadertypin